import { render, staticRenderFns } from "./cangchuCk.vue?vue&type=template&id=74300986&scoped=true&"
import script from "./cangchuCk.vue?vue&type=script&lang=js&"
export * from "./cangchuCk.vue?vue&type=script&lang=js&"
import style0 from "./cangchuCk.vue?vue&type=style&index=0&id=74300986&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74300986",
  null
  
)

export default component.exports